<template>
  <div class="sidebar">
    <div
      class="sidebar-backdrop"
      @click="openMenuAction()"
      v-if="getIsNavOpen"
    ></div>

    <div :class="getIsNavOpen ? 'open' : null" class="sidebar-panel">
      <button class="close-nav" @click="openMenuAction()">
        <img
          src="https://2020-uki.s3.eu-west-2.amazonaws.com/video_partners/img/close-icon.svg"
        />
      </button>
      <div class="nav-container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["getIsNavOpen"]),
  },
  methods: {
    ...mapActions(["openMenuAction"]),
  },
};
</script>

<style>
.sidebar-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  cursor: pointer;
}

.close-nav {
  color: var(--getty-black);
  transition: color 0.5s;
  font-size: 30px;
  position: fixed;
  z-index: 2;
  background: none;
  right: 30px;
  top: 30px;
  width: 40px;
  height: 40px;
  border: 0;
  cursor: pointer;
}

.sidebar-panel {
  overflow-y: auto;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 100;
  padding: 50px 40px;
  width: 100%;
  max-width: 350px;
  transition: transform 0.3s ease;
  transform: translateX(-100%);
}
.sidebar-panel.open {
  transform: translateX(0%);
}
.nav-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  padding: 90px 65px 50px;
}

.sidebar-panel h4 {
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

ul.sidebar-panel-nav {
  padding: 10px 20px;
  list-style-type: none;
}
ul.sidebar-panel-nav li {
  padding: 5px 0;
  font-size: 16px;
}
ul.sidebar-panel-nav li a {
  text-decoration: none;
  color: var(--primary-color);
}
ul.sidebar-panel-nav li a:hover {
  color: var(--button-hover);
}

@media (max-width: 734px) {
  .sidebar-panel {
    max-width: 300px;
  }
  .nav-container {
    padding: 90px 65px 50px 30px;
  }
}
</style>